// Quarks
import Container from 'quarks/Flex';
import Image, { ImageData } from 'quarks/Image';
import Link from 'quarks/Link';
import type { FlexProps } from 'quarks/interpolations/flex';

// Types
import type { ContentfulComponentTestimonial } from 'graphqlTypes';
import type { FC } from 'react';

interface TestimonialCardProps extends FlexProps, ContentfulComponentTestimonial {
  isActive: boolean;
}

const TestimonialCard: FC<TestimonialCardProps> = ({ image, imageLink, isActive, ...props }) => (
  <Link href={imageLink || ''} width="100%">
    <Container width="100%" opacity={isActive ? '1' : '0.25'} transition="opacity 100ms ease-in-out" {...props}>
      <Image
        image={
          (image?.bynderImageDesktop ||
            image?.imageDesktop ||
            image?.bynderImageMobile ||
            image?.imageMobile) as ImageData
        }
        alt={image?.title || ''}
        width="100%"
        objectFit="cover"
        objectPosition="center"
        display="none"
        md={{ display: 'block' }}
      />
      <Image
        image={
          (image?.bynderImageMobile ||
            image?.imageMobile ||
            image?.bynderImageDesktop ||
            image?.imageDesktop) as ImageData
        }
        alt={image?.title || ''}
        width="100%"
        objectFit="cover"
        objectPosition="center"
        md={{ display: 'none' }}
      />
    </Container>
  </Link>
);

export default TestimonialCard;
